// extracted by mini-css-extract-plugin
export default {"IconButton":"group-menu-module__IconButton__Yd_qAne"};